import { Button } from "antd";
import { RenderInputProps } from "../types";
import { PlusOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";
import { useFlow } from "../../../FlowEdit/useFlow";
import FieldEditModal from "../../FieldEditModal";
import {
  FlowNodeInputTypeEnum,
  FlowNodeTypeEnum,
} from "@packages/flow-core/module/node/constants";

export default function AddInputParams({ item, moduleId }: RenderInputProps) {
  const [open, setOpen] = useState(false);
  const { addModuleInput, getAllNodes } = useFlow();
  const isGlobalVariable = useMemo(() => {
    return (
      getAllNodes().find((item) => item.data.moduleId === moduleId)?.data
        .flowType === FlowNodeTypeEnum.globalVariable
    );
  }, [getAllNodes, moduleId]);
  return (
    <>
      <Button
        icon={<PlusOutlined />}
        onClick={() => {
          setOpen(true);
        }}
        type="primary"
      >
        添加输入参数
      </Button>
      <FieldEditModal
        field={item.editField!}
        visible={open}
        onClose={() => setOpen(false)}
        onConfirm={(data) => {
          addModuleInput(moduleId, {
            type: data.inputType || FlowNodeInputTypeEnum.target,
            key: data.key!,
            label: data.label || data.key!,
            description: data.description,
            required: data.required,
            valueType: data.valueType!,
            edit: true,
            editField: item.editField,
            showTargetInApp: isGlobalVariable || undefined,
          });
          setOpen(false);
        }}
      />
    </>
  );
}
